import Markdown from 'markdown-to-jsx';
import cn from 'classnames';

import renderers from '@/components/renderers';

type MarkdownRenderer = {
  content: string;
  company?: string;
  customer?: {
    bio: string;
    name: string;
    photo: {
      url: string;
    };
    title: string;
  };
  isComparisonPage?: boolean;
};

export default function MarkdownRenderer({
  content,
  company,
  customer,
  isComparisonPage,
}: MarkdownRenderer) {
  if (!content) return null;

  return (
    <Markdown
      options={{
        forceBlock: true,
        overrides: {
          CustomerQuote: {
            component: renderers.CustomerQuote,
            props: {
              company,
              customer,
            },
          },
          code: renderers.CodeBlock,
          h1: {
            component: renderers.Heading,
            props: {
              level: 1,
            },
          },
          h2: {
            component: renderers.Heading,
            props: {
              level: 2,
              className: cn({ 'text-center': isComparisonPage }),
            },
          },
          h3: {
            component: renderers.Heading,
            props: {
              level: 3,
            },
          },
          h4: {
            component: renderers.Heading,
            props: {
              level: 4,
            },
          },
          iframe: renderers.IFrame,
          p: renderers.Paragraph,
          a: renderers.Link,
          strong: renderers.Strong,
          blockquote: renderers.Blockquote,
          ol: renderers.OrderedList,
          ul: renderers.UnorderedList,
          li: renderers.ListItem,
          img: renderers.Image,
          hr: renderers.HorizontalRule,
          table: {
            component: renderers.Table,
            props: {
              className: cn({
                'table-auto w-full mt-4 text-gray-800': isComparisonPage,
              }),
            },
          },
          thead: renderers.THead,
          th: {
            component: renderers.TableHeader,
            props: {
              className: cn({
                'border border-gray-200 first:w-1/2 even:bg-purple-100 p-4':
                  isComparisonPage,
              }),
            },
          },
          td: {
            component: isComparisonPage
              ? renderers.ComparisonTableD
              : renderers.TableD,
            props: {
              className: cn({
                'border border-gray-200 text-center first:w-1/2 first:text-left even:bg-purple-100 p-4':
                  isComparisonPage,
              }),
            },
          },
        },
      }}
    >
      {content}
    </Markdown>
  );
}
